// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"418":"addschedules","836":"import"}[chunkId] + "." + {"418":"b718d18e","836":"f1f74da8"}[chunkId] + ".css";
};